import * as actions from './actions'

const SettlementGoogleSheetsStore = {
  state: {},
  getters: {},
  mutations: {},
  actions
}

export default SettlementGoogleSheetsStore
